/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { SxProps, Theme } from '@mui/material/styles';

export const orderItemTableV2TableRowSX: SxProps<Theme> = (theme) => ({
	[theme.breakpoints.down('md')]: {
		'td:not(:first-of-type)': {
			ml: 10,
		},
		borderWidth: '0 0 1px 0',
		borderRadius: '0',
		borderStyle: 'none none solid none',
		borderColor: `grey.300`,
		'&:last-child': {
			borderBottom: 'none',
		},
	},
});
